/**
 * 样条曲线选择状态 Store。
 * 统一管理样条曲线选中状态与样条曲线变化事件。
 */

import { defineStore } from 'pinia';
import { EntityInteractionEventType } from '@puppycad/cad-core';
import { BehaviorSubject, type Observable, type Subscription } from 'rxjs';
import { useViewer } from '../useViewer';
import {
  observeViewerEntityInteraction,
  resolveViewerPrimarySelectedObject,
} from './viewer-selection-helpers';

//------ 样条曲线选择状态 开始------
/**
 * 获取当前主选中的草图样条曲线对象，并观测样条曲线变化事件。
 */
export const useGetSelectSpline = defineStore('get-select-spline', () => {
  let selectedSpline: any | null = null;
  let subscriptions: Subscription[] = [];
  let hasSubscribed = false;
  const splineChanged$ = new BehaviorSubject<any | null>(null);
  const { getViewer } = useViewer();

  

  /**
   * 从实体选择管理器同步当前选中样条曲线。
   */
  function syncFromManager(): void {
    selectedSpline = resolveViewerPrimarySelectedObject(getViewer());
    splineChanged$.next(selectedSpline);
  }

  /**
   * 处理样条曲线选中事件。
   */
  function handleSplineSelected(): void {
    syncFromManager();
  }

  /**
   * 处理选择清空事件。
   */
  function handleSelectionCleared(): void {
    selectedSpline = null;
    splineChanged$.next(null);
  }

  /**
   * 显式开始监听样条曲线选择事件。
   */
  function subscribe(): void {
    const viewer = getViewer();
    const splineSelected$ = observeViewerEntityInteraction(viewer, EntityInteractionEventType.SplineSelected);
    const selectionCleared$ = observeViewerEntityInteraction(viewer, EntityInteractionEventType.SelectionCleared);
    if (!splineSelected$ || !selectionCleared$ || hasSubscribed) {
      return;
    }
    syncFromManager();
    subscriptions = [
      splineSelected$.subscribe(handleSplineSelected),
      selectionCleared$.subscribe(handleSelectionCleared),
    ];
    hasSubscribed = true;
  }

  /**
   * 取消样条曲线选择事件监听。
   */
  function unsubscribe(): void {
    subscriptions.forEach((subscription) => subscription.unsubscribe());
    subscriptions = [];
    hasSubscribed = false;
  }

  return {
    getSelected: (): any | null => selectedSpline,
    onChanged: (): Observable<any | null> => splineChanged$.asObservable(),
    subscribe,
    unsubscribe,
  };
});
//------ 样条曲线选择状态 结束------
